module.exports = __webpack_public_path__ + "static/media/22GalleryPuppets.6a2291d7.jpeg";